import { useQuery } from 'react-query';
import { newsfeedQueryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';

const fetchUnreadNewsfeedCount = ({ clientId }): Promise<null | number> => {
  return authFetch(
    urlWithParams('/Consumer/Newsfeed/UnreadNewsCount', {
      clientId,
    }),
  );
};

export const useUnreadNewsfeedCountQuery = (enabled: boolean) => {
  const clientId = useClientId();

  return useQuery(
    newsfeedQueryKeys.unreadNewsCount(clientId),
    () => fetchUnreadNewsfeedCount({ clientId }),
    {
      enabled,
    },
  );
};
